import { useState } from 'react'
import ModelOpportunities from './ModelOpportunities'

export default function ButtonShowModalOpportunities({ country }) {
  const [isOpen, setIsOpen] = useState(false)

  function handleOnOpenModel() {
    setIsOpen(true)
  }

  function handleOnCloseModel() {
    setIsOpen(false)
  }
  return (
    <>
      <button
        onClick={handleOnOpenModel}
        className="flex w-[126px] justify-between border-2 border-muted-500 bg-white p-2 hover:bg-muted-500"
      >
        <div>الفرص</div>
        <div>({country?.count})</div>
      </button>
      <ModelOpportunities
        isOpen={isOpen}
        onClose={handleOnCloseModel}
        country={country}
      />
    </>
  )
}
